module.exports = __webpack_public_path__ + "img/logoShortWhite.5f85e2d9.png";